/**
 * swapV2 Router
 * @type {{56: string, 97: string}}
 */
export const ROUTERS = {
  97: '0x9Ac64Cc6e4415144C455BD8E4837Fea55603e5c3',
  56: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
}
